// extracted by mini-css-extract-plugin
export default {"registerForm":"RegisterForm_registerForm__dpUJV"};